var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0006C2 6.47776 6.47715 2.00061 12 2.00061C17.5228 2.00061 22 6.47776 22 12.0006C22 17.5235 17.5228 22.0006 12 22.0006C6.47715 22.0006 2 17.5235 2 12.0006Z",
    fill: "#07CD86"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_5314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 12.0006L10.8337 14.9173L16.667 9.08392",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_5314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5.00061)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPay);
export default __webpack_public_path__ + "static/media/checked-pay.c17e0fd2040eadcaf993e08a8ac7e333.svg";
export { ForwardRef as ReactComponent };